import { render, staticRenderFns } from "./projectDetails.vue?vue&type=template&id=cc2c0898"
import script from "./projectDetails.vue?vue&type=script&lang=ts"
export * from "./projectDetails.vue?vue&type=script&lang=ts"
import style0 from "./projectDetails.vue?vue&type=style&index=0&id=cc2c0898&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports